module.exports = __webpack_public_path__ + "static/media/spell-check.4953eb32.svg";